import React, { useState, useEffect } from 'react';
import Admin from '../components/Admin';
import './Admin.css';
import Marquee from 'react-fast-marquee';
import { FaRegUserCircle } from "react-icons/fa";

function Name() {
  const [userDetails, setuserdetails] = useState({});

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('userdetails'))
    setuserdetails(data)
  }, [])


  return (
    <div>
      <div className="admi-form">
        <div className='Name_tag'>
          <div className='profile_icon'>
            <FaRegUserCircle />
          </div>
          <h5>Welcome,</h5>
          <span>
            <Marquee speed={5} direction={'right'}>
              {userDetails.client_name}
            </Marquee>
          </span>
        </div>
        <Admin />
      </div>
    </div>
  );
}

export default Name;